import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { FilePreviewType } from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { JgInspSolution } from 'src/app/modules/shared/models/jg/jg-insp-solution.model';
import {
  JgInspTypeOptions,
  JgInspType,
} from 'src/app/modules/shared/models/jg/jg-insp-type.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { JgInspSolutionService } from 'src/app/modules/shared/services/jg-insp-solution.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';

@Component({
  selector: 'app-dialog-jg-solution-edit',
  templateUrl: './dialog-jg-solution-edit.component.html',
  styleUrls: ['./dialog-jg-solution-edit.component.scss'],
})
export class DialogJgSolutionEditComponent {
  @Input()
  data!: DialogConfig<JgInspSolution>;

  editing: { [name: string]: boolean } = {};

  fileType: FilePreviewType = FilePreviewType.PDF;

  record: JgInspSolution = new JgInspSolution();

  checkList: Array<{ label: string; value: string; checked?: boolean }> = [];

  sectionList: Array<ProjectSection> = [];

  orgDisplay: string = '';

  fileResponses: FileResponse[] = [];

  fileUrls: string[] = [];

  constructor(
    private jgInspSolutionService: JgInspSolutionService,
    private projectSectionService: ProjectSectionService,
    private globalService: GlobalService,
  ) {}

  ngOnInit() {
    this.record = this.handleDataBeforeInit(this.data.data!);
    this.record.projectId = this.globalService.projectId;
    this.getAllSection();

    this.checkList = JgInspTypeOptions.map((item) => ({
      label: item.label,
      value: item.value,
      checked:
        this.record.jgInspTypes?.includes(item.value as JgInspType) || false,
    }));
  }

  onFileChange(fileResponses: FileResponse[]) {
    this.fileResponses = fileResponses;
    this.fileUrls = fileResponses.map((fileResponse) => fileResponse.fileId);
  }

  getAllSection() {
    this.projectSectionService
      .findAll({
        projectId: this.globalService.projectId,
        type: OrganizationType.JG_CHECK,
      })
      .subscribe((response: Array<ProjectSection>) => {
        this.sectionList = response;
        this.onSectionChange();
      });
  }

  onSectionChange() {
    const section = this.sectionList.find(
      (item) => item.id === this.record.jgSectionId,
    );
    if (section) {
      this.orgDisplay =
        section.projectSectionOrganizations
          ?.filter((org) => org.organizationType === OrganizationType.JG_CHECK)
          ?.map((org) => org.organizationName)
          .join(', ') || '';
    }
  }

  edit(name: string) {
    this.editing[name] = true;
  }

  onBlur() {
    this.editing = {};
  }

  private handleDataBeforeInit(response: JgInspSolution): JgInspSolution {
    const data = JSON.parse(JSON.stringify(response)) as JgInspSolution;
    const fileResponse: FileResponse = {
      fileId: data.fileId!,
      fileName: data.fileName!,
      fileMd5: data.fileMd5!,
      fileType: FileType.PDF,
      fileUrl: data.fileId!,
    };
    this.fileResponses = [fileResponse];
    this.fileUrls = [fileResponse.fileId];

    return data;
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  private handleDataBeforeConfirm(response: JgInspSolution): JgInspSolution {
    const data = JSON.parse(JSON.stringify(response)) as JgInspSolution;
    data.fileId = this.fileResponses[0].fileId;
    data.fileName = this.fileResponses[0].fileName;
    data.fileMd5 = this.fileResponses[0].fileMd5;
    data.fileSn = '-';
    data.jgInspTypes = this.checkList
      .filter((item) => item.checked)
      .map((item) => item.value as JgInspType);
    const section = this.sectionList.find(
      (item) => item.id === this.record.jgSectionId,
    );
    if (section) {
      data.organizationId = section.projectSectionOrganizations?.find(
        (org) => org.organizationType === OrganizationType.JG_CHECK,
      )?.organizationId;
      data.sectionId = section.projectSectionSections?.find(
        (section) => section.refSectionType === OrganizationType.CONSTRUCTION,
      )?.refSectionId;
    }
    return data;
  }

  get canConfirm() {
    if (
      !this.record.jgSectionId ||
      this.fileResponses.length === 0 ||
      !this.record.name
    ) {
      return false;
    }
    if (this.checkList.every((item) => !item.checked)) {
      return false;
    }
    return true;
  }

  private submit() {
    this.jgInspSolutionService
      .update(this.handleDataBeforeConfirm(this.record))
      .subscribe((response: boolean) => {
        if (response) {
          this.data.onConfirm!();
        }
      });
  }
}
